import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { ConvenioServiceProxy, UpdateConvenioDto, UpdateEnderecoDto } from '@shared/service-proxies/service-proxies';
import { FormEnderecoComponent } from '@shared/components/form-endereco/form-endereco.component';
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from '@node_modules/rxjs/operators';
import { cnpj } from 'cpf-cnpj-validator';

@Component({
  selector: 'app-edit-convenio',
  templateUrl: './edit-convenio.component.html',
})
export class EditConvenioComponent extends AppComponentBase{
  public convenio: UpdateConvenioDto
  public saving: boolean = false;
  @Output() onSave = new EventEmitter<any>();
  @ViewChild("formEndereco") formEndereco: FormEnderecoComponent;

  constructor(
    injector: Injector,
    private _convenioService: ConvenioServiceProxy,
    public bsModalRef: BsModalRef
  ) { super(injector) }

  protected save() {
    if (!this.formEndereco.IsFormValided() || !this.IsFormValided()) return;
    abp.ui.setBusy();
    this.saving = true;
    this.convenio.endereco = UpdateEnderecoDto.fromJS(this.formEndereco.endereco.toJSON())
    this._convenioService.update(this.convenio).pipe(
      finalize(() => {
        abp.ui.clearBusy();
        this.saving = false;
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    });
  }

  protected IsFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.convenio.cnpj), message: "Informe o CNPJ." },
      { condition: !cnpj.isValid(this.convenio.cnpj), message: "CNPJ inválido." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.razaoSocial), message: "Informe a razão social." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.email), message: "Informe o email." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.representante), message: "Informe o nome do representante." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.cargoRepresentante), message: "Informe o cargo do representante." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  protected onChangeCnpj($event) {
    this.convenio.cnpj = $event;
    if ($event.length == 14) {
      abp.ui.setBusy()
      this._convenioService.getInformacoesEmpresa($event).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe(empresa => {
          if (empresa) {
            this.convenio.razaoSocial = empresa.razaoSocial;
            this.convenio.telefone = empresa.telefone;
            this.convenio.nomeFantasia = empresa.nomeFantasia;
            this.convenio.email = empresa.email;
            this.convenio.ddd = empresa.ddd;
          }
        });
    }
  }
}
